export default {
  title: 'Opłaty',
  subtitle: 'Nadpisanie opłaty serwisowej dla {{company}}.',
  card_title: 'Opłata serwisowa',
  banner: {
    default_summary: 'Domyślne partnera: {{percentage}}% · min {{min}} · maks. {{max}}.',
    override_hint: 'Nadpisz poniżej, aby ustawić inną opłatę dla tej restauracji.',
    suggested_summary: 'Sugerowane wartości początkowe: {{percentage}}% · min {{min}} · maks. {{max}}.',
    suggested_hint: 'Dostosuj je poniżej i zapisz, aby pobierać opłatę serwisową w tej restauracji.',
    own_fee_hint: 'Ta restauracja pobiera własną opłatę, ustawioną poniżej.',
    saved_summary: 'Ostatnio zapisane wartości: {{percentage}}% · min {{min}} · maks. {{max}}.',
    saved_hint: 'Opłata serwisowa jest wyłączona. Zapisz te wartości lub najpierw je zmień, aby ją ponownie włączyć.',
  },
  form: {
    recommended: 'Zalecane: {{value}}',
    percentage: {
      label: 'Procent opłaty serwisowej',
      tooltip: 'Procent wartości zamówienia pobierany od klienta jako opłata serwisowa.',
    },
    min_amount: {
      label: 'Minimalna kwota opłaty serwisowej',
      tooltip: 'Naliczone opłaty poniżej tej kwoty są zaokrąglane w górę do niej.',
    },
    max_amount: {
      label: 'Maksymalna kwota opłaty serwisowej',
      tooltip: 'Opłata serwisowa nigdy nie przekracza tej kwoty, niezależnie od wartości zamówienia.',
    },
  },
  limits:
    'Musi mieścić się w limitach FoodAmigos: maks. {{max_percentage}}% / {{max_amount}}, minimum co najmniej {{min_amount}}.',
  not_charged_notice:
    'W tej restauracji obecnie nie jest pobierana opłata serwisowa. Zapisz opłatę poniżej, aby ją włączyć.',
  zero_percentage_warning:
    'Procent 0% nie wyłącza opłaty serwisowej: opłaty poniżej kwoty minimalnej są zaokrąglane w górę, więc każde zamówienie jest obciążane co najmniej minimum.',
  buttons: {
    edit: 'Edytuj',
    cancel: 'Anuluj',
    save: 'Zapisz',
    reset_to_default: 'Przywróć domyślne partnera',
    turn_off: 'Wyłącz opłatę serwisową',
  },
  toasts: {
    load_error: 'Nie udało się załadować ustawień opłaty serwisowej.',
    failed_to_save_changes: 'Nie udało się zapisać zmian',
    changes_got_saved: 'Zmiany zostały zapisane',
    reset_to_default: 'Nadpisanie usunięte — obowiązuje domyślne ustawienie partnera.',
    reset_to_default_skipped: 'Nadpisanie usunięte — opłata serwisowa nie będzie naliczana, dopóki jej nie zapiszesz.',
    turned_off: 'Opłata serwisowa została wyłączona. Twoje wartości zostaną zachowane na wypadek ponownego włączenia.',
  },
};
